import { render } from "./Yuyue.vue?vue&type=template&id=b9b26f44&ts=true"
import script from "./Yuyue.vue?vue&type=script&lang=ts"
export * from "./Yuyue.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__